<template>
  <div class="table-container">
    <b-row>
      <b-col align="right">
        <b-button
          :disabled="!formLoaded"
          type="button"
          variant="primary"
          class="btn-create btn--smaller mt-2"
          size="sm"
          @click="openUploadDocument"
          title="Crea"
          v-if="canVerb(resource, 'store')"
          ><base-icon name="circled_plus" width="22" height="22" />
          Crea</b-button
        >
      </b-col>
    </b-row>
    <table-document
      :isTableInModal="true"
      :fields="fields"
      @destroy="deleteDocument"
      :repository="repository"
      :resource="resource"
      :filterName="filterName"
      :ref="tableRef"
      :onlyActions="['destroy']"
      noInnerWidth
      @download="downloadDocument"
    >
    </table-document>
    <add-document-modal
      v-if="formLoaded"
      :beFormCreate="beForm[repository]"
      :beRulesCreate="beRules[repository]"
      @upload="uploadDocument"
    >
    </add-document-modal>
  </div>
</template>

<script>
import TableDocument from "@/components/tables/Documents";
import AddDocumentModal from "@/components/modals/addDocument";
import FormMixin from "@/mixins/FormMixin";
import DetailTabAutofetchTableMixin from "@/mixins/DetailTabAutofetchTableMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import BaseIcon from "@/components/BaseIcon";

export default {
  mixins: [FormMixin, DetailTabAutofetchTableMixin, DocumentsMixin],
  name: "Documents",
  data() {
    return {
      filter: this.initFilter(),
      formLoaded: false,
      isLoading: false,
      filterName: "filterVariousAccountingDocumentsDetail",
      repository: "document",
      resource: "documents",
      relation: "book_entry",
      tableRef: "DocumentsDetailTableRef",
      fields: [
        {
          key: "title",
          label: this.getDictionary("title", "document"),
          sortable: false,
          sortKey: "title",
        },
        {
          key: "note",
          label: this.getDictionary("note", "document"),
          sortable: false,
          sortKey: "note",
        },
        {
          key: "extension",
          label: this.getDictionary("source_type", "document"),
          sortable: false,
          sortKey: "extension",
        },
        {
          key: "document_type.text",
          label: this.getDictionary("document_type", "document"),
          sortable: false,
          sortKey: "document_type.text",
        },
        {
          key: "download",
          label: this.getDictionary("Scarica Documento"),
          tdClass: "text-center",
          thStyle: {
            width: "125px",
          },
        },
      ],
    };
  },
  components: {
    BaseIcon,
    TableDocument,
    AddDocumentModal,
  },
  methods: {
    initFilter() {
      let init = {
        byBookEntry: { id: this.resourceId },
      };
      return init;
    },
    openUploadDocument() {
      this.$bvModal.show("addDocumentModal");
    },
  },
  props: {
    resourceId: Number,
  },
  beforeMount() {
    this.fetchCreateForm(this.repository)
      .then(() => {
        this.formLoaded = true;
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
</script>
